<template>
  <div class="helpDetail">
    <div class="contentbg">
      <div
        class="content"
        v-for="item in wordList"
        :key="item.id"
        v-show="item.id == id"
      >
        <div class="question">{{ item.question }}</div>
        <div class="detail">
          {{ item.answer }}
        </div>
      </div>
    </div>
    <div class="dibu">
      <div class="indibu">
        <div
          class="indibuContent"
          @click="hasDone"
          :class="{ disable: doneDis }"
        >
          <img src="../assets/images/done.png" alt="" v-if="doneUnsel" />
          <img src="../assets/images/doneSel.png" alt="" v-if="doneSel" />

          <div class="word" :class="{ active: doneSel }">已解决</div>
        </div>
      </div>
      <div class="indibu">
        <div
          class="indibuContent"
          @click="noDone"
          :class="{ disable: nodoneDis }"
        >
          <img src="../assets/images/nodone.png" alt="" v-if="nodoneUnsel" />
          <img src="../assets/images/nodoneSel.png" alt="" v-if="nodoneSel" />
          <div class="word" :class="{ active: nodoneSel }">未解决</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import { doRem } from "../utils/setrem";
import qs from "qs";
import { Dialog } from "vant";
Vue.use(Icon);
export default {
  mounted() {

    this.getHelpQuestion();
    // this.getToken();
  },
  data() {
    return {
      wordList: [],
      id: "",
      doneUnsel: true,
      doneSel: false,
      nodoneUnsel: true,
      nodoneSel: false,
      doneDis: false,
      nodoneDis: false,
    };
  },
  methods: {
    getHelpQuestion() {
      this.id = this.$route.query.id;
      console.log(this.id);

      let params = qs.stringify({
        metacode: "QUESTIONS",
      });
      this.$axios
        .post("appapi/app/cmsInterface/getCmsInfo", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            res.data.data.forEach((item) => {
              this.wordList.push(item);
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    checkQuestion() {
      let params = qs.stringify({
        quid: this.$route.query.id,
      });
      this.$axios
        .post("appapi/app/cmsInterface/getQuestionIsSolve", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            res.data.data.forEach((item) => {
              this.wordList.push(item);
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    hasDone() {
      let params = qs.stringify({
        quid: this.$route.query.id,
        state: 1,
      });
      this.$axios
        .post("/appapi/app/cmsInterface/questionRecord ", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            let params = qs.stringify({
              quid: this.$route.query.id,
            });
            this.$axios
              .post("/appapi/app/cmsInterface/getQuestionIsSolve ", params)
              .then((res) => {
                if (res.data.result !== 1) {
                  Dialog.alert({
                    message: res.data.reason,
                  }).then(() => {});
                  return;
                }
                if (res.data.result === 1) {
                  if (res.data.state == 1) {
                    this.nodoneDis = true;
                    this.doneUnsel = false;
                    this.doneSel = true;
                    return;
                  } else {
                    Dialog.alert({
                      message: "未点击问题反馈",
                    }).then(() => {});
                    return;
                  }
                }
              })
              .catch((err) => {
                console.error(err);
                Dialog.alert({
                  message: "接口调用失败",
                }).then(() => {});
                return;
              });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    noDone() {
      let params = qs.stringify({
        quid: this.$route.query.id,
        state: 0,
      });
      this.$axios
        .post("/appapi/app/cmsInterface/questionRecord ", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            let params = qs.stringify({
              quid: this.$route.query.id,
            });
            this.$axios
              .post("/appapi/app/cmsInterface/getQuestionIsSolve ", params)
              .then((res) => {
                if (res.data.result !== 1) {
                  Dialog.alert({
                    message: res.data.reason,
                  }).then(() => {});
                  return;
                }
                if (res.data.result === 1) {
                  if (res.data.state == 0) {
                    this.doneDis = true;
                    this.nodoneUnsel = false;
                    this.nodoneSel = true;
                    return;
                  } else {
                    Dialog.alert({
                      message: "未点击问题反馈",
                    }).then(() => {});
                    return;
                  }
                }
              })
              .catch((err) => {
                console.error(err);
                Dialog.alert({
                  message: "接口调用失败",
                }).then(() => {});
                return;
              });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="scss" scoped>
.contentbg {
  height: 100vh;
  background-color: #eef4f6;
  padding: 2.625rem 2rem;
}

.content {
  background-color: #fff;
  border-radius: 1rem;
  .question {
    width: 100%;
    font-size: 2rem;
    padding: 2.625rem 2rem 1.625rem 2rem;
    border-bottom: 1px solid #e5e5e5;
    color: #19212a;
    line-height: 3rem;
    font-weight: 400;
  }
  .detail {
    font-size: 1.75rem;
    line-height: 2.5rem;
    padding: 1.625rem 2rem 3rem 2rem;
    color: #555555;
  }
}

.dibu {
  display: flex;
  font-size: 1.75rem;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1.25rem 0;
  color: #878787;
  background-color: #fff;

  .indibu {
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    .indibuContent {
      display: flex;
      align-items: center;
      img {
        width: 2.625rem;
      }
      .word {
        margin-left: 1.625rem;
        color: #555555;
        font-size: 1.875rem;
      }
      .active {
        color: #338989;
      }
    }
  }
}
.disable {
  pointer-events: none;
}
</style>